import * as React from "react";
import {
  Outlet,
  createRootRoute,
  Link,
  redirect,
} from "@tanstack/react-router";

export const Route = createRootRoute({
  component: RootComponent,
  beforeLoad: ({ location }) => {
    if (location.pathname === "/") {
      throw redirect({
        to: "/dashboard",
      });
    }
  },
  notFoundComponent: () => {
    throw redirect({
      to: "/dashboard",
    });
  },
});

function RootComponent() {
  return (
    <React.Fragment>
      {/* <div>Hello "__root"!</div>
      <Link to="/register" className="[&.active]:font-bold">
          About
        </Link> */}
      <Outlet />
    </React.Fragment>
  );
}
